/**
 * @desc: - 中奖提示窗口
 * @author: klaf
 */
import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as baseAction from '../../actions/baseAction'
import { LOTTERY_MENUS } from '../../constants/menus/lotteryMenus';

export class PrizeTips extends React.Component {

  constructor(props) {
    super(props)
    this.toggleTipStop = this.toggleTipStop.bind(this);
    this.state = {
      tipStopShow: false
    }
  }

  componentWillReceiveProps(nextProps) {
    // 当前显示，下次不显示
    if (this.props.display && !nextProps.display) {
      window.clearTimeout(this.closeCountdown)
    }

    // 当前不显示，下次显示
    if (!this.props.display && nextProps.display) {
      this.closeCountdown = window.setTimeout(function () {
        nextProps.closeFn();
      }, 10000)
    }
  }

  toggleTipStop() {
    if (!this.state.tipStopShow) {
      this.props.$$BASE.stopWinnerNotice();
    } else {
      this.props.$$BASE.startWinnerNotice();
    }
    this.setState({
      tipStopShow: !this.state.tipStopShow
    })
  }

  render() {
    const { display, closeFn, prizeinfo } = this.props;
    const res = prizeinfo ? _.find(_.concat(..._.map(LOTTERY_MENUS, 'lotterys')), { lotteryId: prizeinfo.lotteryid }) : false;
    return <div className="prize-tips-wrap">
      {
        prizeinfo ?
          <div className="prize-winning" style={{ marginTop: (display && !this.state.tipStopShow) ? '0px' : '-200px' }}>
            <div className="pw-left">
              <div className="pw-checkbox">
                <input id="noMoreTips" type="checkbox" className="non-notification"
                  defaultChecked={this.state.tipStopShow ? true : false}
                  onChange={this.toggleTipStop} />
                <label htmlFor="noMoreTips">不再提示</label>
                <span className="close-btn" onClick={closeFn}></span>
              </div>
              <div className="pw-detail">
                <span className="prize-lottery">{prizeinfo.lottery}</span>
                <span className="prize-issue issue">第{prizeinfo.issue}期</span>
              </div>
            </div>
            <div className="pw-right"><span className="prize-money">{prizeinfo.bonus}</span>元</div>
          </div> 
          : ''
      }

    </div>
  }

}

reactMixin(PrizeTips.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrizeTips)